
  var style = require("icon-maker-loader/.tmp/6d5d789f-feed-453f-bcf8-e3f6c88b6f96/icon-maker.js");
  var mainClass = style["icon-maker"];
  if (mainClass) {
    module.exports = mainClass + " " + style["icon-maker-save"];
  } else {
    module.exports = "icon-maker icon-maker-save";
  }
  


//////////////////
// WEBPACK FOOTER
// ./src/icons/save.svg
// module id = 548
// module chunks = 5